import { ChevronDown } from 'lucide-react'
import {
  Button,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from '@teach/ui'
import { LanguageFlag } from '@/components/layout/sidebar/LanguageFlag'
import { useLanguage } from '@/hooks/useLanguage'
import { useMessages } from '@/i18n'
import { messages } from './messages'

/** Язык интерфейса. Те же два языка, что и в меню профиля. */
export const LanguageCard = () => {
  const { language, setLanguage } = useLanguage()
  const m = useMessages(messages)
  const label = language === 'ru' ? 'Русский' : 'English'
  return (
    <div className="flex items-center justify-between gap-3 rounded-2xl bg-foreground/5 px-4 py-3 sm:gap-4 sm:px-6 sm:py-4">
      {/* На телефоне — кеглем поменьше и в одну строку: крупная подпись переносилась на две. */}
      <p className="min-w-0 truncate text-base font-medium sm:text-lg">{m.appLanguage}</p>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="secondary" className="gap-2">
            <LanguageFlag lang={language} />
            {label}
            <ChevronDown className="size-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuRadioGroup
            value={language}
            onValueChange={(value) => setLanguage(value === 'en' ? 'en' : 'ru')}
          >
            <DropdownMenuRadioItem value="ru">
              <LanguageFlag lang="ru" className="mr-2" />
              Русский
            </DropdownMenuRadioItem>
            <DropdownMenuRadioItem value="en">
              <LanguageFlag lang="en" className="mr-2" />
              English
            </DropdownMenuRadioItem>
          </DropdownMenuRadioGroup>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  )
}
